export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-100">
      <div className="px-4 md:px-8 max-w-[1440px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            联系我们
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-[560px] mx-auto">
            有任何问题或建议？欢迎通过以下方式联系我们
          </p>
        </div>

        <div className="max-w-[640px] mx-auto">
          <div className="bg-background-50 rounded-xl border border-background-200/60 p-6 md:p-8">
            <div className="flex flex-col sm:flex-row gap-6 items-start">
              <div className="flex-1 space-y-5">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-primary-500 w-5 h-5 flex items-center justify-center"></i>
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-foreground-800">邮件联系</p>
                    <p className="text-xs text-foreground-500 mt-0.5">contact@90yingshi.com</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-message-2-line text-accent-600 w-5 h-5 flex items-center justify-center"></i>
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-foreground-800">在线反馈</p>
                    <p className="text-xs text-foreground-500 mt-0.5">提交观影建议或内容投稿</p>
                  </div>
                </div>
              </div>

              <div className="flex-1 w-full">
                <div className="space-y-3">
                  <div>
                    <label className="block text-xs font-medium text-foreground-600 mb-1">
                      你的昵称
                    </label>
                    <input
                      type="text"
                      className="w-full px-3 py-2.5 text-sm border border-background-200 rounded-md bg-background-50 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-200 transition-colors"
                      placeholder="请输入昵称"
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-medium text-foreground-600 mb-1">
                      反馈内容
                    </label>
                    <textarea
                      className="w-full px-3 py-2.5 text-sm border border-background-200 rounded-md bg-background-50 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-200 transition-colors resize-none"
                      rows={3}
                      placeholder="请描述你的问题或建议..."
                    ></textarea>
                  </div>
                  <button
                    type="button"
                    className="w-full px-4 py-2.5 bg-primary-500 text-white text-sm font-medium rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    提交反馈
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}